import { PDF, IMAGE } from "../Constants";

export default {
	"image/jpeg": IMAGE.toUpperCase(),
	"image/png": IMAGE.toUpperCase(),
	"image/bmp": IMAGE.toUpperCase(),
	".pdf": PDF.toUpperCase(),
	"application/pdf": PDF.toUpperCase(),
};